import { LoaderCircle } from 'lucide-react'

export function FeatureLoader() {
  return <div className="fixed bottom-0 left-64 right-0 top-[60px] z-30 grid place-items-center bg-white/72 backdrop-blur-[1px] max-[720px]:left-0" role="status" aria-live="polite">
    <LoaderCircle className="animate-spin text-slate-300" size={28} strokeWidth={2.25} aria-hidden="true" />
    <span className="sr-only">Đang tải</span>
  </div>
}
